import '@/common';
import './style.css';
import store from './store';
import { component } from 'riot';
import App from './app/app';
import { appInit } from './app/app.action';
import { registerStore } from '@/common/lib/riot-redux';
import vp from './vp';
import notifyAdmin from '@/common/notify-admin';
import { batchActions } from 'redux-batched-actions';
import { hideLoading } from '@/common/components/kf-loader';
import { clearModal } from '@/common/components/kf-modal';
import { openFailedDialog, openInfoDialog } from '@/common/components/kf-dialog';
window.VP = vp;
const componentErrorHandler = (timing) => async (error, name) => {
  const errMessage = `${name}_${timing}_${error?.message || ''}
  URL: ${location.href}
  環境: ${navigator.userAgent}
  ${error?.stack || ''}`;
  notifyAdmin(errMessage, error?.message || '');
  console.error(error);
  await store.dispatch(
    batchActions([
      hideLoading(),
      clearModal(),
    ])
  );
  store.dispatch(openFailedDialog('不明なエラーが発生しました。ページを再度読み込んでください。'));
};

const storeOptions = {
  onMountError: componentErrorHandler('onMount'),
  onUpdateError: componentErrorHandler('onUpdate'),
  onUnmountError: componentErrorHandler('onUnmount'),
};

registerStore(store, storeOptions);
const main = () => {
  if (location.hash === '') {
    location.replace('/top/#');
  }
  const [path, key] = location.hash.replace('#', '').split('/');
  if (path === 'informowner') {
    store.dispatch(appInit({ key }));
    document.title = '予約CTIv2';
  }
  component(App)(document.getElementById('root'));
  try {
    localStorage.getItem('test'); 
  } catch (error) {
    store.dispatch(openInfoDialog('クッキーもしくはストレージが使用できないため、正常に動作しない可能性があります。'));
  }
};

window.addEventListener('load', main);